import { SortDirection } from 'shared/constants';
import { PaginationDto } from 'model/Pagination.dto';
import { UserFilterStatus } from 'model/UserFilter';

import {
  mapPermissionGroupDtoToModel,
  PermissionGroupDto,
  PermissionGroupModel,
} from './PermissionGroup.dto';

export type PaginatedUserListSendDto = {
  sort?: {
    [sortKey in 'name' | 'email' | 'status' | 'groups']?: SortDirection;
  };
  page?: number;
  limit?: number;
  filter?: {
    search?: string;
    permissionGroupId?: string;
    status?: UserFilterStatus;
  };
};

export type PaginatedUserListDto = {
  pagination: PaginationDto;
  data: UserDto[];
};

export type PaginatedUserListModel = {
  pagination: PaginationDto;
  data: UserModel[];
};

export type UserDto = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  permissions?: string[];
  groups?: PermissionGroupDto[];
  role: string;
  isClientAdmin: boolean;
};
export type UserSendDto = {
  id?: string;
  firstName?: string;
  lastName?: string;
  email: string;
  password: string;
  department?: number;
  permissions?: string[];
  groups?: string[];
  isClientAdmin?: boolean;
};

export type UserModel = {
  id?: string;
  firstName?: string;
  lastName?: string;
  email: string;
  permissions?: string[];
  groups?: PermissionGroupModel[];
  department?: number;
  password?: string;
  role?: string;
  isClientAdmin?: boolean;
};

export function mapUserModelToSendDto(model: UserModel): UserSendDto {
  return {
    id: model.id,
    firstName: model.firstName,
    lastName: model.lastName,
    email: model.email,
    password: model.password,
    isClientAdmin: model.isClientAdmin,
    department: model.department,
    groups: model.groups.map((permissionGroup) => permissionGroup.id),
  };
}

export function mapUserDtoToModel(dto: UserDto): UserModel {
  return {
    id: dto.id,
    firstName: dto.firstName,
    lastName: dto.lastName,
    email: dto.email,
    permissions: dto.permissions,
    role: dto.role,
    isClientAdmin: dto.isClientAdmin,
    groups: dto.groups ? dto.groups.map(mapPermissionGroupDtoToModel) : [],
  };
}

export namespace UserModel {
  export function getPermission(user: UserModel, objectType: string): string | undefined {
    return user?.permissions?.find((permission) => permission.includes(objectType));
  }

  export function getPermissionGroup(user: UserModel, projectId: number): PermissionGroupModel {
    return user?.groups?.find((group) => group.objectIdentifier === `project-${projectId}`);
  }

  export function addPermissionGroup(
    userModel: UserModel,
    newPermissionGroup: PermissionGroupModel,
  ): UserModel {
    return {
      ...userModel,
      groups: [
        ...(userModel.groups?.filter(
          (group) => group.objectIdentifier !== newPermissionGroup.objectIdentifier,
        ) ?? []),
        newPermissionGroup,
      ],
    };
  }
}
